import { whitelineApi } from '@/shared/api';
import { UserActionResponse } from './types';

export type {
  UserActionCode,
  UserActionDetails,
  UserActionResponse,
  UserActionShipmentDetails,
  UserActionSubjectResponse,
  UserActionSubjectType
} from './types';

export interface GetUserActionsRequest {
  org_id?: string;
  shipment_id?: string;
  user_id: string;
}

export type GetUserActionsResponse = UserActionResponse[];

export interface CompleteUserActionByIdRequest {
  actionId: string;
  created_at?: string;
}

export type CompleteUserActionByIdResponse = void;

export const completeUserActionById = async (
  payload: CompleteUserActionByIdRequest
): Promise<CompleteUserActionByIdResponse> => {
  const requestBody = payload.created_at ? { created_at: payload.created_at } : undefined;

  if (requestBody) {
    await whitelineApi.post(`/api/actions/${payload.actionId}/complete`, requestBody);
    return;
  }

  await whitelineApi.post(`/api/actions/${payload.actionId}/complete`);
};

export const getUserActions = async (
  payload: GetUserActionsRequest
): Promise<GetUserActionsResponse> => {
  const response = await whitelineApi.get<GetUserActionsResponse>('/api/actions', {
    params: payload
  });

  return response.data;
};